// // Flight Plan Integration Manager - Robust HOT OSM Based Solution
// // Integrates RobustAutoGridGenerator with EnhancedWPMLGenerator

// import { RobustAutoGridGenerator } from './robust-grid-generator.js'
// // import { EnhancedWPMLGenerator } from './enhanced-wpml-generator.js'
// import * as turf from '@turf/turf'

// class FlightPlanManager {
//   constructor () {
//     this.gridGenerator = new RobustAutoGridGenerator()
//     // this.wpmlGenerator = new EnhancedWPMLGenerator()
//     this.currentFlightPlan = null
//     this.validationResults = null
//   }

//   /**
//    * Generate complete flight plan with auto grid generation
//    * @param {Object} config - Flight plan configuration
//    * @returns {Promise<Object>} Complete flight plan with statistics and validation
//    */
//   async generateAutoGridFlightPlan (config) {
//     try {
//       //   this.validateConfiguration(config);

//       // Extract configuration parameters
//       const { polygon, aircraft, payload, missionParams } = config

//       // Generate flight plan using robust algorithms
//       const flightPlan = this.gridGenerator.generateFlightPlan(
//         polygon,
//         aircraft,
//         payload,
//         missionParams
//       )

//       // Enhance with additional processing
//       const enhancedPlan = this.enhanceFlightPlan(flightPlan, config)

//       // Validate the generated plan
//       this.validationResults = this.validateFlightPlan(enhancedPlan)
//       // Store current plan
//       this.currentFlightPlan = enhancedPlan

//       return {
//         flightPlan: enhancedPlan,
//         validation: this.validationResults,
//         metadata: this.generatePlanMetadata(enhancedPlan),
//       }
//     } catch (error) {
//       throw new Error(`Flight plan generation failed: ${error.message}`)
//     }
//   }

//   // In your FlightManager class
//   clearFlightPlan () {
//     const root = getRoot()
//     const map = (root as any).$map
//     const leaflet = (root as any).$leaflet

//     if (!map || !leaflet) return

//     // Remove the current flight layer if it exists
//     if (window.currentFlightLayer) {
//       map.removeLayer(window.currentFlightLayer)
//       window.currentFlightLayer = null
//     }

//     // Also clear any individual waypoint markers and polylines
//     if (window.waypointMarkers) {
//       window.waypointMarkers.forEach(marker => map.removeLayer(marker))
//       window.waypointMarkers = []
//     }

//     if (window.flightPath) {
//       map.removeLayer(window.flightPath)
//       window.flightPath = null
//     }
//   }

//   /**
//    * Export flight plan as DJI compatible KMZ file
//    * @param {Object} options - Export options
//    * @returns {Promise<Blob>} KMZ file blob
//    */
//   // async exportKMZ (options = {}) {
//   //   if (!this.currentFlightPlan) {
//   //     throw new Error('No flight plan available for export')
//   //   }

//   //   // Validate plan before export
//   //   const validation = this.wpmlGenerator.validateFlightPlan(
//   //     this.currentFlightPlan
//   //   )
//   //   if (!validation.valid) {
//   //     throw new Error(
//   //       `Flight plan validation failed: ${validation.errors.join(', ')}`
//   //     )
//   //   }

//   //   // Generate KMZ file
//   //   const kmzBlob = await this.wpmlGenerator.generateKMZ(
//   //     this.currentFlightPlan,
//   //     options
//   //   )

//   //   return kmzBlob
//   // }

//   /**
//    * Calculate detailed mission parameters
//    * @param {Object} aircraft - Aircraft specifications
//    * @param {Object} payload - Payload specifications
//    * @param {Object} missionParams - Mission parameters
//    * @returns {Object} Detailed calculations
//    */
//   calculateMissionParameters (aircraft, payload, missionParams) {
//     return this.gridGenerator.calculateFlightParameters(
//       payload,
//       missionParams.altitude,
//       missionParams.forwardOverlap,
//       missionParams.sideOverlap,
//       missionParams.gsd
//     )
//   }

//   /**
//    * Validate configuration before processing
//    * @param {Object} config - Configuration to validate
//    */
//   validateConfiguration (config) {
//     const errors = []

//     if (!config.polygon) {
//       errors.push('Polygon is required')
//     } else if (!this.isValidGeoJSONPolygon(config.polygon)) {
//       errors.push('Invalid GeoJSON polygon')
//     }

//     if (!config.aircraft) {
//       errors.push('Aircraft specification is required')
//     }

//     if (!config.payload) {
//       errors.push('Payload specification is required')
//     }

//     if (!config.missionParams) {
//       errors.push('Mission parameters are required')
//     } else {
//       const mp = config.missionParams

//       if (!mp.altitude || mp.altitude < 20 || mp.altitude > 500) {
//         errors.push('Altitude must be between 20-500 meters')
//       }

//       if (
//         !mp.forwardOverlap ||
//         mp.forwardOverlap < 60 ||
//         mp.forwardOverlap > 95
//       ) {
//         errors.push('Forward overlap must be between 60-95%')
//       }

//       if (!mp.sideOverlap || mp.sideOverlap < 60 || mp.sideOverlap > 95) {
//         errors.push('Side overlap must be between 60-95%')
//       }
//     }

//     if (errors.length > 0) {
//       throw new Error(`Configuration validation failed: ${errors.join(', ')}`)
//     }
//   }

//   /**
//    * Enhance flight plan with additional processing
//    * @param {Object} flightPlan - Base flight plan
//    * @param {Object} config - Original configuration
//    * @returns {Object} Enhanced flight plan
//    */
//   enhanceFlightPlan (flightPlan, config) {
//     const enhanced = { ...flightPlan }

//     // Add home point if specified
//     if (config.homePoint) {
//       enhanced.homePoint = config.homePoint
//     } else {
//       // Auto-generate home point from polygon centroid
//       enhanced.homePoint = this.generateDefaultHomePoint(config.polygon)
//     }

//     // Add safety buffers and no-fly zone checks
//     enhanced.safetyChecks = this.performSafetyChecks(flightPlan, config)

//     // Add weather considerations
//     enhanced.weatherFactors = this.calculateWeatherFactors(flightPlan)

//     // Add backup landing sites
//     enhanced.emergencyLandingSites = this.identifyEmergencyLandingSites(
//       config.polygon
//     )

//     // Add mission optimization suggestions
//     enhanced.optimizations = this.generateOptimizationSuggestions(flightPlan)

//     return enhanced
//   }

//   /**
//    * Validate complete flight plan
//    * @param {Object} flightPlan - Flight plan to validate
//    * @returns {Object} Validation results
//    */
//   validateFlightPlan (flightPlan) {
//     const validation = {
//       valid: true,
//       errors: [],
//       warnings: [],
//       recommendations: [],
//     }

//     // Basic structure validation
//     if (!flightPlan.waypoints || flightPlan.waypoints.length < 2) {
//       validation.errors.push('Minimum 2 waypoints required')
//     }

//     // Mission duration validation
//     if (flightPlan.statistics.estimatedFlightTime > 25) {
//       validation.warnings.push(
//         `Long flight time: ${flightPlan.statistics.estimatedFlightTime.toFixed(
//           1
//         )} minutes`
//       )
//     }

//     // Battery usage validation
//     if (flightPlan.statistics.estimatedBatteryUsage > 80) {
//       validation.warnings.push(
//         `High battery usage: ${flightPlan.statistics.estimatedBatteryUsage.toFixed(
//           1
//         )}%`
//       )
//     }

//     if (flightPlan.statistics.estimatedBatteryUsage > 100) {
//       validation.errors.push('Mission exceeds battery capacity')
//     }

//     // GSD quality validation
//     if (flightPlan.parameters.gsd > 5) {
//       validation.warnings.push(
//         `GSD ${flightPlan.parameters.gsd}cm may be too low for detailed mapping`
//       )
//     }

//     if (flightPlan.parameters.gsd < 1) {
//       validation.recommendations.push('Excellent GSD for high-detail mapping')
//     }

//     // Overlap validation
//     if (
//       flightPlan.parameters.forwardOverlap < 70 ||
//       flightPlan.parameters.sideOverlap < 70
//     ) {
//       validation.warnings.push('Low overlap may result in gaps in coverage')
//     }

//     // Speed validation
//     if (
//       flightPlan.parameters.optimalSpeed >
//       flightPlan.aircraft.maxSpeed * 0.8
//     ) {
//       validation.warnings.push('High speed may affect image quality')
//     }

//     // Photo count validation
//     if (flightPlan.statistics.photoCount > 1000) {
//       validation.recommendations.push(
//         'Large number of photos - ensure sufficient storage'
//       )
//     }

//     validation.valid = validation.errors.length === 0
//     return validation
//   }

//   /**
//    * Generate default home point from polygon centroid
//    * @param {Object} polygon - GeoJSON polygon
//    * @returns {Object} Home point
//    */
//   generateDefaultHomePoint (polygon) {
//     const centroid = turf.centroid(polygon)
//     return {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: centroid.geometry.coordinates,
//       },
//       properties: {
//         name: 'Auto-generated Home Point',
//         altitude: 0,
//       },
//     }
//   }

//   /**
//    * Perform safety checks on flight plan
//    * @param {Object} flightPlan - Flight plan to check
//    * @param {Object} config - Original configuration
//    * @returns {Object} Safety check results
//    */
//   performSafetyChecks (flightPlan, config) {
//     return {
//       altitudeCheck: this.checkAltitudeLimits(flightPlan, config),
//       airspaceCheck: this.checkAirspaceRestrictions(flightPlan),
//       obstacleCheck: this.checkObstacles(flightPlan),
//       weatherCheck: this.checkWeatherConditions(flightPlan),
//     }
//   }

//   checkAltitudeLimits (flightPlan) {
//     const maxLegalAltitude = 120 // meters AGL in most jurisdictions
//     const altitude = flightPlan.parameters.altitude

//     return {
//       compliant: altitude <= maxLegalAltitude,
//       altitude: altitude,
//       limit: maxLegalAltitude,
//       message:
//         altitude > maxLegalAltitude
//           ? `Altitude ${altitude}m exceeds legal limit of ${maxLegalAltitude}m`
//           : 'Altitude within legal limits',
//     }
//   }

//   checkAirspaceRestrictions (flightPlan) {
//     console.log(flightPlan)
//     // Placeholder for airspace checking
//     // Would integrate with NOTAM/airspace APIs in production
//     return {
//       clear: true,
//       restrictions: [],
//       message: 'No known airspace restrictions (check local NOTAMs)',
//     }
//   }

//   checkObstacles (flightPlan) {
//     console.log(flightPlan)

//     // Placeholder for obstacle detection
//     // Would integrate with terrain/obstacle databases in production
//     return {
//       clear: true,
//       obstacles: [],
//       message: 'No obvious obstacles detected',
//     }
//   }

//   checkWeatherConditions (flightPlan) {
//     console.log(flightPlan)

//     // Placeholder for weather checking
//     // Would integrate with weather APIs in production
//     return {
//       suitable: true,
//       conditions: 'Unknown',
//       message: 'Check current weather conditions before flight',
//     }
//   }

//   /**
//    * Calculate weather-related factors
//    * @param {Object} flightPlan - Flight plan
//    * @returns {Object} Weather factors
//    */
//   calculateWeatherFactors (flightPlan) {
//     return {
//       windImpact: this.calculateWindImpact(flightPlan),
//       temperatureEffects: this.calculateTemperatureEffects(flightPlan),
//       recommendedTimeWindow: this.getRecommendedTimeWindow(),
//     }
//   }

//   calculateWindImpact (flightPlan) {
//     // Simplified wind impact calculation
//     const baseFlightTime = flightPlan.statistics.estimatedFlightTime
//     return {
//       estimatedDelay: baseFlightTime * 0.1, // 10% buffer for wind
//       recommendedWindLimit: 10, // m/s
//       message: 'Consider wind speed impact on flight time and battery usage',
//     }
//   }

//   calculateTemperatureEffects (flightPlan) {
//     console.log(flightPlan)

//     return {
//       batteryEfficiency: 'Temperature affects battery performance',
//       recommendedRange: [-10, 40], // Celsius
//       message: 'Extreme temperatures reduce battery life and performance',
//     }
//   }

//   getRecommendedTimeWindow () {
//     return {
//       startTime: '1 hour after sunrise',
//       endTime: '1 hour before sunset',
//       avoid: ['High winds', 'Precipitation', 'Low visibility'],
//       message: 'Best results in calm conditions with good lighting',
//     }
//   }

//   /**
//    * Identify potential emergency landing sites
//    * @param {Object} polygon - Mission area polygon
//    * @returns {Array} Emergency landing sites
//    */
//   identifyEmergencyLandingSites (polygon) {
//     // Simplified approach - would use terrain analysis in production
//     const centroid = turf.centroid(polygon)
//     const buffer = turf.buffer(polygon, 1, { units: 'kilometers' })
//     console.log(buffer)

//     return [
//       {
//         type: 'Feature',
//         geometry: {
//           type: 'Point',
//           coordinates: centroid.geometry.coordinates,
//         },
//         properties: {
//           name: 'Primary Emergency Site',
//           suitability: 'Good',
//           distance: 0,
//         },
//       },
//     ]
//   }

//   /**
//    * Generate optimization suggestions
//    * @param {Object} flightPlan - Flight plan to optimize
//    * @returns {Array} Optimization suggestions
//    */
//   generateOptimizationSuggestions (flightPlan) {
//     const suggestions = []

//     // Battery optimization
//     if (flightPlan.statistics.estimatedBatteryUsage > 70) {
//       suggestions.push({
//         type: 'battery',
//         suggestion: 'Consider splitting mission into multiple flights',
//         impact: 'Reduces risk of battery depletion',
//       })
//     }

//     // Speed optimization
//     if (flightPlan.parameters.optimalSpeed < 5) {
//       suggestions.push({
//         type: 'speed',
//         suggestion: 'Increase altitude to allow higher speed',
//         impact: 'Reduces total flight time',
//       })
//     }

//     // Coverage optimization
//     if (flightPlan.parameters.forwardOverlap > 85) {
//       suggestions.push({
//         type: 'overlap',
//         suggestion: 'Reduce forward overlap to 80% to increase efficiency',
//         impact: 'Fewer photos needed, shorter flight time',
//       })
//     }

//     return suggestions
//   }

//   /**
//    * Generate comprehensive metadata
//    * @param {Object} flightPlan - Flight plan
//    * @returns {Object} Metadata
//    */
//   generatePlanMetadata (flightPlan) {
//     return {
//       generated: new Date().toISOString(),
//       generator: 'Flight Plan Manager v2.0',
//       algorithm: 'HOT-OSM-Enhanced',
//       version: '2.0.0',
//       aircraft: {
//         model: flightPlan.aircraft.name,
//         id: flightPlan.aircraft.id,
//       },
//       payload: {
//         model: flightPlan.payload.name,
//         id: flightPlan.payload.id,
//       },
//       coverage: {
//         area: flightPlan.statistics.coverageArea,
//         gsd: flightPlan.statistics.averageGSD,
//         photos: flightPlan.statistics.photoCount,
//       },
//       performance: {
//         flightTime: flightPlan.statistics.estimatedFlightTime,
//         distance: flightPlan.statistics.totalDistance,
//         batteryUsage: flightPlan.statistics.estimatedBatteryUsage,
//       },
//       quality: {
//         forwardOverlap: flightPlan.parameters.forwardOverlap,
//         sideOverlap: flightPlan.parameters.sideOverlap,
//         lineSpacing: flightPlan.parameters.lineSpacing,
//       },
//     }
//   }

//   /**
//    * Validate GeoJSON polygon
//    * @param {Object} polygon - Polygon to validate
//    * @returns {boolean} Is valid
//    */
//   isValidGeoJSONPolygon (polygon) {
//     try {
//       return (
//         polygon &&
//         polygon?.type === 'Feature' &&
//         polygon.geometry &&
//         polygon.geometry?.type === 'Polygon' &&
//         polygon.geometry.coordinates &&
//         polygon.geometry.coordinates.length > 0 &&
//         polygon.geometry.coordinates[0].length >= 4
//       )
//     } catch (error) {
//       console.log(error)
//       return false
//     }
//   }

//   /**
//    * Get current flight plan summary
//    * @returns {Object|null} Flight plan summary
//    */
//   getFlightPlanSummary () {
//     if (!this.currentFlightPlan) {
//       return null
//     }

//     return {
//       waypoints: this.currentFlightPlan.statistics.totalWaypoints,
//       distance: this.currentFlightPlan.statistics.totalDistance,
//       duration: this.currentFlightPlan.statistics.estimatedFlightTime,
//       photos: this.currentFlightPlan.statistics.photoCount,
//       coverage: this.currentFlightPlan.statistics.coverageArea,
//       gsd: this.currentFlightPlan.statistics.averageGSD,
//       battery: this.currentFlightPlan.statistics.estimatedBatteryUsage,
//       valid: this.validationResults?.valid || false,
//     }
//   }
// }

// export default FlightPlanManager

// Flight Plan Integration Manager - Robust HOT OSM Based Solution
// Integrates RobustAutoGridGenerator with EnhancedWPMLGenerator

import { RobustAutoGridGenerator } from './robust-grid-generator.js'
// import { EnhancedWPMLGenerator } from './enhanced-wpml-generator.js'
import * as turf from '@turf/turf'

class FlightPlanManager {
  constructor () {
    this.gridGenerator = new RobustAutoGridGenerator()
    // this.wpmlGenerator = new EnhancedWPMLGenerator()
    this.currentFlightPlan = null
    this.validationResults = null
  }

  /**
   * Generate complete flight plan with auto grid generation
   * @param {Object} config - Flight plan configuration
   * @returns {Promise<Object>} Complete flight plan with statistics and validation
   */
  async generateAutoGridFlightPlan (config) {
    try {
      //   this.validateConfiguration(config);

      // Extract configuration parameters
      const { polygon, aircraft, payload, missionParams } = config

      // Generate flight plan using robust algorithms
      const flightPlan = this.gridGenerator.generateFlightPlan(
        polygon,
        aircraft,
        payload,
        missionParams
      )

      // Enhance with additional processing
      const enhancedPlan = this.enhanceFlightPlan(flightPlan, config)

      // Validate the generated plan
      this.validationResults = this.validateFlightPlan(enhancedPlan)
      // Store current plan
      this.currentFlightPlan = enhancedPlan

      return {
        flightPlan: enhancedPlan,
        validation: this.validationResults,
        metadata: this.generatePlanMetadata(enhancedPlan),
      }
    } catch (error) {
      throw new Error(`Flight plan generation failed: ${error.message}`)
    }
  }

  /**
   * Clear flight plan visualization from map
   * @param {Object} map - Leaflet map instance
   * @param {Object} leaflet - Leaflet library reference
   */
  clearFlightPlan (map, leaflet) {
    if (!map || !leaflet) {
      console.warn('Map or Leaflet not available for clearing flight plan')
      return
    }

    // Remove the current flight layer if it exists
    if (window.currentFlightLayer) {
      map.removeLayer(window.currentFlightLayer)
      window.currentFlightLayer = null
    }

    // Also clear any individual waypoint markers and polylines
    if (window.waypointMarkers) {
      window.waypointMarkers.forEach(marker => {
        if (map.hasLayer(marker)) {
          map.removeLayer(marker)
        }
      })
      window.waypointMarkers = []
    }

    if (window.flightPath && map.hasLayer(window.flightPath)) {
      map.removeLayer(window.flightPath)
      window.flightPath = null
    }

    // Clear grid lines if they exist
    if (window.gridLines) {
      window.gridLines.forEach(line => {
        if (map.hasLayer(line)) {
          map.removeLayer(line)
        }
      })
      window.gridLines = []
    }

    console.log('Flight plan visualization cleared')
  }

  /**
   * Export flight plan as DJI compatible KMZ file
   * @param {Object} options - Export options
   * @returns {Promise<Blob>} KMZ file blob
   */
  // async exportKMZ (options = {}) {
  //   if (!this.currentFlightPlan) {
  //     throw new Error('No flight plan available for export')
  //   }

  //   // Validate plan before export
  //   const validation = this.wpmlGenerator.validateFlightPlan(
  //     this.currentFlightPlan
  //   )
  //   if (!validation.valid) {
  //     throw new Error(
  //       `Flight plan validation failed: ${validation.errors.join(', ')}`
  //     )
  //   }

  //   // Generate KMZ file
  //   const kmzBlob = await this.wpmlGenerator.generateKMZ(
  //     this.currentFlightPlan,
  //     options
  //   )

  //   return kmzBlob
  // }

  /**
   * Calculate detailed mission parameters
   * @param {Object} aircraft - Aircraft specifications
   * @param {Object} payload - Payload specifications
   * @param {Object} missionParams - Mission parameters
   * @returns {Object} Detailed calculations
   */
  calculateMissionParameters (aircraft, payload, missionParams) {
    return this.gridGenerator.calculateFlightParameters(
      payload,
      missionParams.altitude,
      missionParams.forwardOverlap,
      missionParams.sideOverlap,
      missionParams.gsd
    )
  }

  /**
   * Validate configuration before processing
   * @param {Object} config - Configuration to validate
   */
  validateConfiguration (config) {
    const errors = []

    if (!config.polygon) {
      errors.push('Polygon is required')
    } else if (!this.isValidGeoJSONPolygon(config.polygon)) {
      errors.push('Invalid GeoJSON polygon')
    }

    if (!config.aircraft) {
      errors.push('Aircraft specification is required')
    }

    if (!config.payload) {
      errors.push('Payload specification is required')
    }

    if (!config.missionParams) {
      errors.push('Mission parameters are required')
    } else {
      const mp = config.missionParams

      if (!mp.altitude || mp.altitude < 20 || mp.altitude > 500) {
        errors.push('Altitude must be between 20-500 meters')
      }

      if (
        !mp.forwardOverlap ||
        mp.forwardOverlap < 60 ||
        mp.forwardOverlap > 95
      ) {
        errors.push('Forward overlap must be between 60-95%')
      }

      if (!mp.sideOverlap || mp.sideOverlap < 60 || mp.sideOverlap > 95) {
        errors.push('Side overlap must be between 60-95%')
      }
    }

    if (errors.length > 0) {
      throw new Error(`Configuration validation failed: ${errors.join(', ')}`)
    }
  }

  /**
   * Enhance flight plan with additional processing
   * @param {Object} flightPlan - Base flight plan
   * @param {Object} config - Original configuration
   * @returns {Object} Enhanced flight plan
   */
  enhanceFlightPlan (flightPlan, config) {
    const enhanced = { ...flightPlan }

    // Add home point if specified
    if (config.homePoint) {
      enhanced.homePoint = config.homePoint
    } else {
      // Auto-generate home point from polygon centroid
      enhanced.homePoint = this.generateDefaultHomePoint(config.polygon)
    }

    // Add safety buffers and no-fly zone checks
    enhanced.safetyChecks = this.performSafetyChecks(flightPlan, config)

    // Add weather considerations
    enhanced.weatherFactors = this.calculateWeatherFactors(flightPlan)

    // Add backup landing sites
    enhanced.emergencyLandingSites = this.identifyEmergencyLandingSites(
      config.polygon
    )

    // Add mission optimization suggestions
    enhanced.optimizations = this.generateOptimizationSuggestions(flightPlan)

    return enhanced
  }

  /**
   * Validate complete flight plan
   * @param {Object} flightPlan - Flight plan to validate
   * @returns {Object} Validation results
   */
  validateFlightPlan (flightPlan) {
    const validation = {
      valid: true,
      errors: [],
      warnings: [],
      recommendations: [],
    }

    // Basic structure validation
    if (!flightPlan?.waypoints || flightPlan?.waypoints.length < 2) {
      validation.errors.push('Minimum 2 waypoints required')
    }

    // Mission duration validation
    if (flightPlan?.statistics?.estimatedFlightTime > 25) {
      validation.warnings.push(
        `Long flight time: ${flightPlan?.statistics?.estimatedFlightTime.toFixed(
          1
        )} minutes`
      )
    }

    // Battery usage validation
    if (flightPlan?.statistics?.estimatedBatteryUsage > 80) {
      validation.warnings.push(
        `High battery usage: ${flightPlan?.statistics?.estimatedBatteryUsage.toFixed(
          1
        )}%`
      )
    }

    if (flightPlan?.statistics?.estimatedBatteryUsage > 100) {
      validation.errors.push('Mission exceeds battery capacity')
    }

    // GSD quality validation
    if (flightPlan?.parameters?.gsd > 5) {
      validation.warnings.push(
        `GSD ${flightPlan?.parameters?.gsd}cm may be too low for detailed mapping`
      )
    }

    if (flightPlan?.parameters?.gsd < 1) {
      validation.recommendations.push('Excellent GSD for high-detail mapping')
    }

    // Overlap validation
    if (
      flightPlan?.parameters?.forwardOverlap < 70 ||
      flightPlan?.parameters?.sideOverlap < 70
    ) {
      validation?.warnings.push('Low overlap may result in gaps in coverage')
    }

    // Speed validation
    if (
      flightPlan?.parameters?.optimalSpeed >
      flightPlan?.aircraft?.maxSpeed * 0.8
    ) {
      validation?.warnings.push('High speed may affect image quality')
    }

    // Photo count validation
    if (flightPlan?.statistics?.photoCount > 1000) {
      validation?.recommendations.push(
        'Large number of photos - ensure sufficient storage'
      )
    }

    validation.valid = validation.errors.length === 0
    return validation
  }

  /**
   * Generate default home point from polygon centroid
   * @param {Object} polygon - GeoJSON polygon
   * @returns {Object} Home point
   */
  generateDefaultHomePoint (polygon) {
    const centroid = turf.centroid(polygon)
    return {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: centroid.geometry.coordinates,
      },
      properties: {
        name: 'Auto-generated Home Point',
        altitude: 0,
      },
    }
  }

  /**
   * Perform safety checks on flight plan
   * @param {Object} flightPlan - Flight plan to check
   * @param {Object} config - Original configuration
   * @returns {Object} Safety check results
   */
  performSafetyChecks (flightPlan, config) {
    return {
      altitudeCheck: this.checkAltitudeLimits(flightPlan, config),
      airspaceCheck: this.checkAirspaceRestrictions(flightPlan),
      obstacleCheck: this.checkObstacles(flightPlan),
      weatherCheck: this.checkWeatherConditions(flightPlan),
    }
  }

  checkAltitudeLimits (flightPlan) {
    const maxLegalAltitude = 120 // meters AGL in most jurisdictions
    const altitude = flightPlan.parameters.altitude

    return {
      compliant: altitude <= maxLegalAltitude,
      altitude: altitude,
      limit: maxLegalAltitude,
      message:
        altitude > maxLegalAltitude
          ? `Altitude ${altitude}m exceeds legal limit of ${maxLegalAltitude}m`
          : 'Altitude within legal limits',
    }
  }

  checkAirspaceRestrictions (flightPlan) {
    console.log(flightPlan)
    // Placeholder for airspace checking
    // Would integrate with NOTAM/airspace APIs in production
    return {
      clear: true,
      restrictions: [],
      message: 'No known airspace restrictions (check local NOTAMs)',
    }
  }

  checkObstacles (flightPlan) {
    console.log(flightPlan)

    // Placeholder for obstacle detection
    // Would integrate with terrain/obstacle databases in production
    return {
      clear: true,
      obstacles: [],
      message: 'No obvious obstacles detected',
    }
  }

  checkWeatherConditions (flightPlan) {
    console.log(flightPlan)

    // Placeholder for weather checking
    // Would integrate with weather APIs in production
    return {
      suitable: true,
      conditions: 'Unknown',
      message: 'Check current weather conditions before flight',
    }
  }

  /**
   * Calculate weather-related factors
   * @param {Object} flightPlan - Flight plan
   * @returns {Object} Weather factors
   */
  calculateWeatherFactors (flightPlan) {
    return {
      windImpact: this.calculateWindImpact(flightPlan),
      temperatureEffects: this.calculateTemperatureEffects(flightPlan),
      recommendedTimeWindow: this.getRecommendedTimeWindow(),
    }
  }

  calculateWindImpact (flightPlan) {
    // Simplified wind impact calculation
    const baseFlightTime = flightPlan.statistics.estimatedFlightTime
    return {
      estimatedDelay: baseFlightTime * 0.1, // 10% buffer for wind
      recommendedWindLimit: 10, // m/s
      message: 'Consider wind speed impact on flight time and battery usage',
    }
  }

  calculateTemperatureEffects (flightPlan) {
    console.log(flightPlan)

    return {
      batteryEfficiency: 'Temperature affects battery performance',
      recommendedRange: [-10, 40], // Celsius
      message: 'Extreme temperatures reduce battery life and performance',
    }
  }

  getRecommendedTimeWindow () {
    return {
      startTime: '1 hour after sunrise',
      endTime: '1 hour before sunset',
      avoid: ['High winds', 'Precipitation', 'Low visibility'],
      message: 'Best results in calm conditions with good lighting',
    }
  }

  /**
   * Identify potential emergency landing sites
   * @param {Object} polygon - Mission area polygon
   * @returns {Array} Emergency landing sites
   */
  identifyEmergencyLandingSites (polygon) {
    // Simplified approach - would use terrain analysis in production
    const centroid = turf.centroid(polygon)
    const buffer = turf.buffer(polygon, 1, { units: 'kilometers' })
    console.log(buffer)

    return [
      {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: centroid.geometry.coordinates,
        },
        properties: {
          name: 'Primary Emergency Site',
          suitability: 'Good',
          distance: 0,
        },
      },
    ]
  }

  /**
   * Generate optimization suggestions
   * @param {Object} flightPlan - Flight plan to optimize
   * @returns {Array} Optimization suggestions
   */
  generateOptimizationSuggestions (flightPlan) {
    const suggestions = []

    // Battery optimization
    if (flightPlan.statistics.estimatedBatteryUsage > 70) {
      suggestions.push({
        type: 'battery',
        suggestion: 'Consider splitting mission into multiple flights',
        impact: 'Reduces risk of battery depletion',
      })
    }

    // Speed optimization
    if (flightPlan.parameters.optimalSpeed < 5) {
      suggestions.push({
        type: 'speed',
        suggestion: 'Increase altitude to allow higher speed',
        impact: 'Reduces total flight time',
      })
    }

    // Coverage optimization
    if (flightPlan.parameters.forwardOverlap > 85) {
      suggestions.push({
        type: 'overlap',
        suggestion: 'Reduce forward overlap to 80% to increase efficiency',
        impact: 'Fewer photos needed, shorter flight time',
      })
    }

    return suggestions
  }

  /**
   * Generate comprehensive metadata
   * @param {Object} flightPlan - Flight plan
   * @returns {Object} Metadata
   */
  generatePlanMetadata (flightPlan) {
    return {
      generated: new Date().toISOString(),
      generator: 'Flight Plan Manager v2.0',
      algorithm: 'HOT-OSM-Enhanced',
      version: '2.0.0',
      aircraft: {
        model: flightPlan.aircraft.name,
        id: flightPlan.aircraft.id,
      },
      payload: {
        model: flightPlan.payload.name,
        id: flightPlan.payload.id,
      },
      coverage: {
        area: flightPlan.statistics.coverageArea,
        gsd: flightPlan.statistics.averageGSD,
        photos: flightPlan.statistics.photoCount,
      },
      performance: {
        flightTime: flightPlan.statistics.estimatedFlightTime,
        distance: flightPlan.statistics.totalDistance,
        batteryUsage: flightPlan.statistics.estimatedBatteryUsage,
      },
      quality: {
        forwardOverlap: flightPlan.parameters.forwardOverlap,
        sideOverlap: flightPlan.parameters.sideOverlap,
        lineSpacing: flightPlan.parameters.lineSpacing,
      },
    }
  }

  /**
   * Validate GeoJSON polygon
   * @param {Object} polygon - Polygon to validate
   * @returns {boolean} Is valid
   */
  isValidGeoJSONPolygon (polygon) {
    try {
      return (
        polygon &&
        polygon?.type === 'Feature' &&
        polygon?.geometry &&
        polygon?.geometry?.type === 'Polygon' &&
        polygon?.geometry?.coordinates &&
        polygon?.geometry?.coordinates.length > 0 &&
        polygon?.geometry?.coordinates[0].length >= 4
      )
    } catch (error) {
      console.log(error)
      return false
    }
  }

  /**
   * Get current flight plan summary
   * @returns {Object|null} Flight plan summary
   */
  getFlightPlanSummary () {
    if (!this.currentFlightPlan) {
      return null
    }

    return {
      waypoints: this.currentFlightPlan.statistics.totalWaypoints,
      distance: this.currentFlightPlan.statistics.totalDistance,
      duration: this.currentFlightPlan.statistics.estimatedFlightTime,
      photos: this.currentFlightPlan.statistics.photoCount,
      coverage: this.currentFlightPlan.statistics.coverageArea,
      gsd: this.currentFlightPlan.statistics.averageGSD,
      battery: this.currentFlightPlan.statistics.estimatedBatteryUsage,
      valid: this.validationResults?.valid || false,
    }
  }
}

export default FlightPlanManager
